import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'duration',
    standalone: false
})

export class DurationPipe implements PipeTransform {
  transform(milliseconds: number): string {
    return moment.utc(milliseconds).format(milliseconds < 3600000 ? "mm:ss" : "HH:mm:ss");
  }
}
